/* eslint-disable @typescript-eslint/no-empty-interface */
import { createReducer, on } from '@ngrx/store';

import { showHelp } from './keyboard.actions';

export const KEYBOARD_FEATURE_KEY = 'keyboard';

export interface KeyboaardPartialState {
  readonly [KEYBOARD_FEATURE_KEY]: KeyboardState;
}

export interface KeyboardState {
  showHelp: boolean;
}

const initialState: KeyboardState = {
  showHelp: false,
};

export const reducer = createReducer(
  initialState,
  on(showHelp, (s, { show }) => {
    return { ...s, showHelp: show };
  })
);
